/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  RemoveCustomFieldProofMutationResponse,
  RemoveCustomFieldProofPathParams,
} from "../types/RemoveCustomFieldProof.ts"

export const removeCustomFieldProofMutationKey = () =>
  [
    { url: "/v1/custom-field/remove-custom-field-proof/:customFieldValueId" },
  ] as const

export type RemoveCustomFieldProofMutationKey = ReturnType<
  typeof removeCustomFieldProofMutationKey
>

/**
 * @description Remove the proof of a custom field value
 * @summary Remove custom field proof
 * {@link /v1/custom-field/remove-custom-field-proof/:customFieldValueId}
 */
export async function removeCustomFieldProof(
  customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    RemoveCustomFieldProofMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/custom-field/remove-custom-field-proof/${customFieldValueId}`,
    ...requestConfig,
  })
  return res
}

export function removeCustomFieldProofMutationOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = removeCustomFieldProofMutationKey()
  return mutationOptions<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
    },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ customFieldValueId }) => {
      return removeCustomFieldProof(customFieldValueId, config)
    },
  })
}

/**
 * @description Remove the proof of a custom field value
 * @summary Remove custom field proof
 * {@link /v1/custom-field/remove-custom-field-proof/:customFieldValueId}
 */
export function useRemoveCustomFieldProof<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<RemoveCustomFieldProofMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? removeCustomFieldProofMutationKey()

  const baseOptions = removeCustomFieldProofMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
    },
    TContext
  >

  return useMutation<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<RemoveCustomFieldProofMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      customFieldValueId: RemoveCustomFieldProofPathParams["customFieldValueId"]
    },
    TContext
  >
}
